import * as yup from "yup";

export interface IIVRCalling {
    id: number;
    hr_No: string;
    accountant_No: string;
}

export const IVRCallingSchema = yup.object().shape({
    id: yup.number().optional(),
    hr_No: yup.string()
        .typeError("HR Number must be a string")
        .required("HR Number is required"),
    accountant_No: yup.string()
        .typeError("Accountant Number must be a string")
        .required("Accountant Number is required"),
});
